import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import "./app.config";

new Vue({
  store,
  render: h => h(App)
}).$mount("#app");

/**
 * The holding page was mistakenly built as a PWA that installed a service
 * worker that cached the holding page for offline use. This was never removed
 * causing the holding page to still be the page loaded by browsers rather than
 * the correct site
 */
navigator.serviceWorker.getRegistrations().then(registrations => {
  for (let registration of registrations) {
    registration.unregister();
  }
});
